export default Object.freeze({
  MAX_SIZE: 6,
  START_INDEX: 0,
  END_INDEX: 5
});
